//node_modules
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Notifications from "./components/Notifications";
import Organizations from "./components/Organizations";
import UserManagement from "./components/UserManagement";

// pages
import UserCreatePage from "./components/UserManagement/UserCreatePage.jsx";
import UserEditPage from "./components/UserManagement/UserEditPage.jsx";
import UserPasswordPage from "./components/UserManagement/UserPasswordPage.jsx";
import OrganizationCreatePage from "./components/OrganizationManagement/OrganizationCreatePage.jsx";
import OrganizationEditPage from "./components/OrganizationManagement/OrganizationEditPage.jsx";

//components
import SidebarMenu from "../../components/SidebarMenu.jsx";
import { useMobile } from "../../hooks/useMobile";

//styles
 import * as styles from "./AdminDashboard.module.css";

function AdminDashboard() {
  useMobile();
  return (
    <div className={styles.adminPortal}>
      <SidebarMenu
        menuItems={[
          {
            link: "/app/admin/users",
            id: "users",
            title: "User Management",
            icon: "pi-users",
          },
          {
            link: "/app/admin/notification-options",
            id: "notification-options",
            title: "Notification Options",
            icon: "pi-bell",
          },
          {
            link: "/app/admin/organizations",
            id: "organizations",
            title: "Organizations",
            icon: "pi-building",
          },
        ]}
        title={"Admin Portal"}
      />
      <div className={styles.routeContainer}>
        <Routes>
          <Route path="users" element={<UserManagement />} />
          <Route path="users/create" element={<UserCreatePage />} />
          <Route path="users/:id/edit" element={<UserEditPage />} />
          <Route path="users/:id/password" element={<UserPasswordPage />} />

          <Route path="organizations" element={<Organizations />} />
          <Route
            path="organizations/create"
            element={<OrganizationCreatePage />}
          />
          <Route
            path="organizations/:id/edit"
            element={<OrganizationEditPage />}
          />

          <Route path="notification-options" element={<Notifications />} />

          <Route index element={<Navigate to="users" />} />
          <Route path="*" element={<Navigate to="users" />} />
        </Routes>
      </div>
    </div>
  );
}

export default AdminDashboard;
